import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import ContactForm from '../components/common/ContactForm';

const PrimaryButton = styled(Link).attrs({ className: 'about-primary-button' })`
  display: inline-block;
  background-color: var(--accent-color);
  color: var(--primary-color);
  padding: 0.8rem 1.5rem;
  border-radius: 4px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #c89a3e;
  }
`;

const AboutPage = () => {
  return (
    <div>
      <div>
        <div className="flex flex-col items-center justify-start w-full !bg-cover !bg-center pt-[14vw]" style={{
          backgroundImage: "url('/images/header-big.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}>
          <h1 className="text-[30px] md:text-[55px] leading-tight font-light text-white text-center mb-6 px-8 md:px-16">A Moment Beneath the Stars</h1>
          <p className="px-8 md:px-16 text-center max-w-[920px] mx-auto text-md mb-12 text-[16px] md:text-[20px]">It began with a simple idea: What if we could capture the night sky from a life-changing moment?<br /><br />
            That thought became a passion — transforming real astronomical data into stunning, personalized star maps. From falling in love to a child's birth, the stars witnessed it all. We created this to help you remember those moments — beautifully.
          </p>
        </div>

        <div className="px-8 md:px-16 w-full grid !grid-cols-1 md:!grid-cols-2 gap-16 items-center relative md:mt-20">
          <img src="/images/gradients/gradient-5.svg" className="absolute top-[-540px] left-[-590px] !min-w-[216px] h-auto" />

          <div className="md:order-1 order-2 w-full overflow-hidden">
            <h2 className="mt-10 md:mt-0 text-[30px] md:text-[55px] leading-tight font-light">What We Do</h2>
            <p className="text-md mb-6">We turn the night sky into art.</p>
            <p className="text-md mb-6">Using real star data and precise astronomical algorithms, we recreate how the stars, constellations, and planets appeared above any location on Earth at any moment in time — past, present, or future. Each piece is a one-of-a-kind map, customized with your own message, design, and meaning.</p>
            <p className="text-md">It's more than a print. It's a time capsule in the stars.</p>
          </div>

          <div className="md:order-2 order-1">
            <img src="/images/about-photo-1.svg" alt="About Map" className="md:pl-20 w-[861px] -mb-[20px] h-auto" />
          </div>
        </div>

        <div className="px-8 md:px-16 w-full grid !grid-cols-1 md:!grid-cols-2 gap-16 items-center relative mt-20">
          <div className="relative mt-10 md:mt-0">
            <img src="/images/about-photo-2.png" alt="About Map" className="w-[861px] h-auto relative z-10" />
            <img src="/images/gradients/gradient-5.svg" className="absolute top-[-340px] left-[120px] !min-w-[816px] h-auto" />
            <img src="/images/gradients/gradient-6.svg" className="absolute top-0 left-[-320px] !min-w-[616px] h-auto opacity-70" />
          </div>

          <div className="w-full md:pl-20 mt-10 md:mt-20 mb-20">
            <h2 className="text-[30px] md:text-[55px] leading-tight font-light mb-6 md:mb-0">How It Works</h2>
            <p className="text-[20px] md:text-[31px] mb-1">1. Choose your moment</p>
            <p className="text-md mb-5">Pick any date and location — from the place you first met to the night your journey began.</p>
            <p className="text-[20px] md:text-[31px] mb-1">2. Make it yours</p>
            <p className="text-md mb-5">Personalize your star map with colors, layouts, and a custom message that captures your memory.</p>
            <p className="text-[20px] md:text-[31px] mb-1">3. We craft & deliver</p>
            <p className="text-md">We create your map using real astronomical data, print it with care, and ship it worldwide — free.</p>
          </div>
        </div>

        <div className="w-full px-8 md:px-16 flex flex-col items-center justify-center mb-20 mt-10 md:mt-20 text-center">
          <h2 className="text-[30px] md:text-[55px] leading-tight font-light mb-6 md:mb-0">Ready to Map Your Moment?</h2>
          <p className="text-md mb-5">The stars above are unique to your story.<br />Let us help you turn them into something unforgettable.</p>

          <Link to="/create" className="button-new mt-6">
            Create Your Star Map
          </Link>
        </div>

        {/* Contact Form Section */}
        <ContactForm />

      </div>
    </div>
  );
};

export default AboutPage; 